import { render, staticRenderFns } from "./formOpen.vue?vue&type=template&id=3fd40f1c&scoped=true&"
import script from "./formOpen.vue?vue&type=script&lang=js&"
export * from "./formOpen.vue?vue&type=script&lang=js&"
import style0 from "./formOpen.vue?vue&type=style&index=0&id=3fd40f1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fd40f1c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VIcon,VRadio,VRadioGroup,VSwitch,VTextField,VTextarea,VTooltip})
